import styled from '@emotion/styled';

import { spacing } from 'presentations/views/styles';
import Logo from 'presentations/views/components/atoms/Logo';
import Skeleton from 'presentations/views/components/atoms/Skeleton';

interface Props {}

export default function Component(props: Props) {
  return (
    <LoadingContainer>
      <Content>
        <LogoContainer>
          <Logo width={160} isDarkable />
        </LogoContainer>
        <div>
          <Skeleton width={140} height={8} variant="rectangular" />
        </div>
      </Content>
    </LoadingContainer>
  );
}

const LoadingContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
const LogoContainer = styled.div`
  margin-bottom: ${spacing(16)};
`;
